import React from 'react';
import Imagewebp from '../../../components/Image_webp';
import Imagepng from '../../components/Image_png';

const Columbox = () => {
  return (
   <>
   <div className="ad-dash-s2">
					<ul>
						<li>
							<div>
								<Imagepng text={'ic-1'} />
								<h2>248</h2>
								<h4>All Students</h4>
								<a href="admin-all-users.html" className="fclick"></a>
							</div>
						</li>
						<li>
							<div>
								<Imagepng text={'shop'} />
								<h2>132</h2>
								<h4>All Listing</h4>
								<a href="admin-all-listings.html" className="fclick"></a>
							</div>
						</li>
						<li>
							<div>
								<Imagepng text={'calendar'} />
								<h2>24</h2>
								<h4>All Events</h4>
								<a href="admin-event.html" className="fclick"></a>
							</div>
						</li>
						<li>
							<div>
								<Imagepng text={'cart'} />
								<h2>24</h2>
								<h4>All Products</h4>
								<a href="admin-all-products.html" className="fclick"></a>
							</div>
						</li>
						<li>
							<div>
								<Imagepng text={'blog1'} />
								<h2>39</h2>
								<h4>All Blog Posts</h4>
								<a href="admin-all-blogs.html" className="fclick"></a>
							</div>
						</li>
					</ul>
				</div>
				<div className="ad-dash-s4">
					<ul>
						<li>
							<div className="cor-1">
								<h4>New Users</h4>
								<h2>User requests</h2>
								<span>07</span>
								<p>This count for today how many get quote and enquiry you got it.</p>
								<a href="admin-new-user-requests.html" className="fclick"></a>
							</div>
						</li>
						<li>
							<div className="cor-2">
								<h4>Leads & Enquiry</h4>
								<h2>Get Quote</h2>
								<span>133</span>
								<p>This count for last month get quote and enquiry you got it.</p>
								<a href="admin-all-enquiry.html" className="fclick"></a>
							</div>
						</li>
						<li>
							<div className="cor-3">
								<h4>Enquiry</h4>
								<h2>Ad Request</h2>
								<span>33</span>
								<p>This count for total get quote and enquiry leads you got it till to end.</p>
								<a href="admin-ads-request.html" className="fclick"></a>
							</div>
						</li>
					</ul>
				</div>
				<div className="ad-dash-s3">
					<ul>
						<li>
							<div className="ad-cou">
								<div> <span>Premium Plus Users</span>
									<h4>23</h4>
								</div>
								<div>
									<Imagepng text={'ic-9'} />
								</div>
								<a href="admin-premium-plus-users.html" className="fclick"></a>
							</div>
						</li>
						<li>
							<div className="ad-cou">
								<div> <span>Premium Users</span>
									<h4>04</h4>
								</div>
								<div>
									<Imagepng text={'ic-8'} />
								</div>
								<a href="admin-premium-users.html" className="fclick"></a>
							</div>
						</li>
						<li>
							<div className="ad-cou">
								<div> <span>Standard Users</span>
									<h4>16</h4>
								</div>
								<div>
									<Imagepng text={'ic-10'} />
								</div>
								<a href="admin-standard-users.html" className="fclick"></a>
							</div>
						</li>
						<li>
							<div className="ad-cou">
								<div> <span>Free Users</span>
									<h4>69</h4>
								</div>
								<div>
									<Imagepng text={'ic-11'} />
								</div>
								<a href="admin-free-users.html" className="fclick"></a>
							</div>
						</li>
					</ul>
				</div>
				<div className="ad-dash-s3 ad-dash-s5">
					<ul>
						<li>
							<div className="ad-cou">
								<div>
									<Imagepng text={'ic-14'} />
								</div>
								<div> <span>Category</span>
									<h4>13</h4>
								</div>
								<a href="admin-all-category.html" className="fclick"></a>
							</div>
						</li>
						<li>
							<div className="ad-cou">
								<div>
									<Imagepng text={'ic-12'} />
								</div>
								<div> <span>Sub Category</span>
									<h4>45</h4>
								</div>
								<a href="admin-all-category.html" className="fclick"></a>
							</div>
						</li>
						<li>
							<div className="ad-cou">
								<div>
									<Imagepng text={'ic-13'} />
								</div>
								<div> <span>Cities</span>
									<h4>48358</h4>
								</div>
								<a href="admin-all-city.html" className="fclick"></a>
							</div>
						</li>
						<li>
							<div className="ad-cou">
								<div>
									<Imagepng text={'ic-15'} />
								</div>
								<div> <span>Notifications Send</span>
									<h4>12</h4>
								</div>
								<a href="admin-notification-all.html" className="fclick"></a>
							</div>
						</li>
					</ul>
				</div>
   </>
  )
}

export default Columbox